import { Entity } from './entities.interface';
import { DateParams, Page, PageParams, SortParams } from './page.interface';

export type BusinessScopeType =
  | 0 //yes
  | 1 // no
  | 2; // partial

export type ActivityType =
  | 'C01' // Manutenção e reparação de veículos automóveis
  | 'C02' // Manutenção e reparação de motociclos, de duas peças e acessórios
  | 'C03' // Alojamento, restauração e similares
  | 'C04' // Atividades de salões e cabeleireiro e institutos de beleza
  | 'C05' // Saúde
  | 'C06' // Educação
  | 'C07' // Imóveis
  | 'C09' // Atividades veterinárias
  | 'C08' // Lares
  | 'C10' // Aquisição de passes mensais para utilização de transportes públicos coletivos
  | 'C11' // Ginásios
  | 'C12' // Jornais e revistas
  | 'C99'; // Outros

export enum ExpenseCategory {
  C01 = 'C01',
  C02 = 'C02',
  C03 = 'C03',
  C04 = 'C04',
  C05 = 'C05',
  C06 = 'C06',
  C07 = 'C07',
  C08 = 'C08',
  C09 = 'C09',
  C10 = 'C10',
  C11 = 'C11',
  C12 = 'C12',
  C99 = 'C99',
}

export interface Expense {
  id: number;
  documentNumber?: string;
  emitter?: Entity;
  emittedAt: Date | string;
  totalValue: number;
  taxValue: number;
  taxRate: number;
  hasBusinessScope?: BusinessScopeType;
  activityType?: ActivityType;
  byUser: boolean;
}

export interface ExpenseList extends Page<Expense> {
  isImporting: boolean;
}

export interface ExpensesImport {
  password: string;
  year: Date | string;
}

export interface ExpenseParams extends PageParams, DateParams, SortParams {
  imported?: 0 | 1;
  search?: string;
}

export interface ExpenseUpdate {
  emitterId: number;
  documentNumber?: string;
  emittedAt: Date | string;
  totalValue: number;
  taxValue: number;
  hasBusinessScope: BusinessScopeType;
  activityType: ActivityType;
}
